<div style="overflow-x: hidden;" class="table" id="faq-container">
  <div class="card" style="height: 100%;" id="faq-card">
    <div class="card-header" id="faq-card-header">
      <h3 id="faq-title"><strong i18n="@@frequentlyAskedQuestions">Preguntas Frecuentes</strong></h3>
    </div>
    <div class="card-body" style="overflow-y: auto; overflow-x: hidden; height: 100%;" id="faq-card-body">
      @for (question of dataFrequentQuestion; track question) {
        <p style="cursor:pointer;" (click)=select(question.order) id="faq-p-question-{{question.order}}">
          <strong id="faq-strong-question-{{question.order}}">{{question.order}}. {{question.question}}</strong>
        </p>
        @if (isSelected(question.order)) {
          <div [innerHTML]="question.answer" id="faq-div-answer-{{question.order}}"></div>
        }
      }
    </div>
  </div>
</div>
